import React, { useContext } from "react";
import { Route, useRouteMatch, Switch } from "polyrouter";
import { RoomDetailsRouter } from "./View/RoomDetails";
import { RoomsList } from "./List/RoomsList";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";

export const RoomsRouter: React.FC = () => {
  const { tenant } = useContext(SelectedTenantContext);
  const tenantId = tenant?.id ?? "";
  const root = useRouteMatch().path;
  return (
    <Switch>
      <Route path={`${root}/details/:roomId`} component={RoomDetailsRouter} />
      <Route path={root} render={() => <RoomsList tenantId={tenantId} />} />
    </Switch>
  );
};

export default RoomsRouter;
